import { Routes, Route } from "react-router-dom";
import VehicleHiringEntryCreateScreen from "screens/App/CRM/VehilceHiringEntry/VehicleHiringEntryCreateScreen";
import VehicleHiringEntryDetailScreen from "screens/App/CRM/VehilceHiringEntry/VehicleHiringEntryDetailScreen";
import VehicleHiringEntryEditScreen from "screens/App/CRM/VehilceHiringEntry/VehicleHiringEntryEditScreen";
import VehicleHiringEntryListScreen from "screens/App/CRM/VehilceHiringEntry/VehicleHiringEntryListScreen";
import NotFoundScreen from "screens/NotFoundScreen";


const VehicleHiringEntryRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<VehicleHiringEntryListScreen />} />
      <Route path="create" element={<VehicleHiringEntryCreateScreen />} />
      <Route path=":id/detail" element={<VehicleHiringEntryDetailScreen />} />
      <Route path=":id/edit" element={<VehicleHiringEntryEditScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default VehicleHiringEntryRouter;